import { ReactNode, useEffect, useRef, useState } from "react";
import { cn } from "../../lib/utils";
import Container from "../ui/Container";
import MerciLogo from "../../assets/header/MerciLogo.png";
import MenuIcon from "../../assets/header/MenuIcon";
import CloseIcon from "../../assets/header/CloseIcon";

const Link = ({
  children,
  href,
  subMenu,
  countItems,
  handleOpenChange,
  isOpen,
  className,
  isActive,
}: {
  children: ReactNode;
  href?: string;
  subMenu?: ReactNode;
  countItems?: number;
  isOpen?: boolean;
  handleOpenChange?: (isOpen: boolean) => void;
  className?: string;
  isActive?: boolean;
}) => {
  return (
    <div
      onClick={() => {
        if (href !== undefined) {
          window.location.href = href;
          return;
        }

        if (handleOpenChange === undefined) {
          return;
        }
        handleOpenChange(!isOpen);
      }}
      className={cn(
        "flex flex-col border-t border-black text-[#4D4D4D] transition-all duration-500 hover:text-secondary-foreground uppercase font-bold text-[13px] tracking-wide text-left p-[20px] h-[60px]",
        isActive && "text-[#CF1E20] underline underline-offset-4",
        isOpen && countItems === 5 && "h-[268px]",
        isOpen && countItems === 6 && "h-[306px]",
        className,
      )}
    >
      <span className={cn(isOpen && "underline underline-offset-4")}>{children}</span>
      <div className="pt-[20px] overflow-hidden">{subMenu}</div>
    </div>
  );
};

const SubmenuLink = ({
  children,
  href,
}: {
  children: ReactNode;
  href: string;
}) => {
  return (
    <div
      onClick={() => {
        if (href !== undefined) {
          window.location.href = href;
          return;
        }
      }}
      className="flex flex-col text-black transition-colors hover:text-secondary-foreground normal-case font-bold text-[13px] tracking-wide text-left p-[10px] last:pb-0"
    >
      {children}
    </div>
  );
};

const BurgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [subMenuOpen, setSubMenuOpen] = useState<null | string>(null);

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];

    if (isOpen) {
      html.classList.add("overflow-hidden");
    } else {
      html.classList.remove("overflow-hidden");
    }
    return (): void => {
      html.classList.remove("overflow-hidden");
    };
  }, [isOpen]);

  return (
    <>
      <div
        ref={ref}
        className={cn(
          "fixed bg-white w-full justify-center transition-all duration-500 z-10 flex h-[60px]",
          !isOpen && "shadow-lg",
        )}
      >
        <Container className="w-full flex items-center">
          <div className="flex-1 h-[37px] transition-all duration-500 flex justify-start ml-[16px]">
            <a href="https://www.merci.de">
              <img
                src={MerciLogo}
                alt="Merci logo"
                className="max-h-full max-w-full"
              />
            </a>
          </div>
          <div className="w-[20px] mr-[16px]" />
        </Container>
      </div>
      <div
        className={cn(
          "fixed w-full z-[9] bg-white transition-all duration-500 h-[100vh] mt-[-100vh] overflow-hidden",
          isOpen && "mt-[60px]",
        )}
      >
        <Link href="https://www.merci.de/de/start">Start</Link>
        <Link href="https://www.merci.de/de/black-and-white-selection">Black & White</Link>
        <Link href="https://herzliche-intelligenz.merci.de" isActive>
          Herzliche Intelligenz
        </Link>
        <Link
          countItems={5}
          handleOpenChange={(isOpenState) => {
            if (!isOpenState) {
              setSubMenuOpen(null);
              return;
            }
            setSubMenuOpen("gestalten");
          }}
          isOpen={subMenuOpen === "gestalten"}
          subMenu={
            <>
              <SubmenuLink href="https://www.merci.de/de/sags-mit-merci/uebersicht">
                Übersicht
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/merci-designer">
                merci personalisieren
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/sags-mit-merci">
                mit merci basteln
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/sags-mit-merci/lovely-statements">
                Lovely Statements
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/sags-mit-merci/downloads">
                Downloads
              </SubmenuLink>
            </>
          }
        >
          merci gestalten
        </Link>
        <Link
          countItems={6}
          isOpen={subMenuOpen === "Produkte"}
          handleOpenChange={(isOpenState) => {
            if (!isOpenState) {
              setSubMenuOpen(null);
              return;
            }
            setSubMenuOpen("Produkte");
          }}
          subMenu={
            <>
              <SubmenuLink href="https://www.merci.de/de/produkte/uebersicht">
                Übersicht
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/produkte/merci-finest-selection">
                merci Finest Selection
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/produkte/merci-lovelies">
                merci lovelies
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/produkte/merci-together">
                merci together
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/produkte/merci-petits">
                merci Petits
              </SubmenuLink>
              <SubmenuLink href="https://www.merci.de/de/produkte/merci-tafelschokolade">
                merci Tafelschokolade
              </SubmenuLink>
            </>
          }
        >
          Produkte
        </Link>
        <div />
      </div>
    </>
  );
};

export default BurgerMenu;
